import { render, staticRenderFns } from "./thank-you-lolly.view.vue?vue&type=template&id=0727412d&"
import script from "./thank-you-lolly.view.ts?vue&type=script&lang=js&"
export * from "./thank-you-lolly.view.ts?vue&type=script&lang=js&"
import style0 from "./thank-you-lolly.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports